import React from "react";
import CHLogo from "../../Assets/Images/logo.png";

const Logo = ({ noMargin }) => (
  <img
    src={CHLogo}
    width="70%"
    style={!noMargin ? { marginTop: "0.1rem", marginLeft: "0.7rem" } : {}}
    alt="Logo"
  />
);
export default Logo;
